var getImageDimensions = function (data) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.onload = function () {
            resolve({ height: image.height, width: image.width, ratio: image.width / image.height });
        };
        image.src = data;
    });
};
export default getImageDimensions;
//# sourceMappingURL=getImageDimensions.js.mapvar getImageDimensions = function (data) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.onload = function () {
            resolve({ height: image.height, width: image.width, ratio: image.width / image.height });
        };
        image.src = data;
    });
};
export default getImageDimensions;
//# sourceMappingURL=getImageDimensions.js.map